import { BoxProps, Stack } from "@mui/material";

import FieldValue from "@/common/components/Form/Display/FieldValue";
import { GeneralAddressDto } from "@/core/api/generated/v1";

interface Props {
  address?: GeneralAddressDto;
  sx?: BoxProps["sx"];
}

export function GeneralAddressDisplay({ address, sx }: Props) {
  return (
    <Stack sx={sx} gap={1}>
      <FieldValue label='Country' isEmpty={!address?.country}>
        {address?.country}
      </FieldValue>
      <FieldValue label='City' isEmpty={!address?.city}>
        {address?.city}
      </FieldValue>
      <FieldValue label='State' isEmpty={!address?.state}>
        {address?.state}
      </FieldValue>
      <FieldValue label='Line 1' isEmpty={!address?.line1}>
        {address?.line1}
      </FieldValue>
      <FieldValue label='Line 2' isEmpty={!address?.line2}>
        {address?.line2}
      </FieldValue>
      <FieldValue label='Postal code' isEmpty={!address?.postalCode}>
        {address?.postalCode}
      </FieldValue>
    </Stack>
  );
}
